import React, { useEffect } from 'react'
import styled from 'styled-components'
import moment from 'moment'
import { useDispatch, useSelector } from 'react-redux'
import { AppState } from 'redux/config/store'
import { employeePlatformActions } from 'redux/employeePlatform/employeePlatformSlice'
import { FinchEmploymentTypes } from 'redux/employeePlatform/employeePlatformTypes'
import GridCard from 'employee-platform/shared/components/GridCard'
import Text from 'core-system/Text'
import palette from 'core-system/Themes/palette'
import InsightsIcon from 'core-system/Icons/Sidebar/Insights'
import { monthTripBucket, summarizeTrips, totalPostedSpend } from '../dashboardSummary'
import { useDashboardMoney } from '../useDashboardMoney'

const Stats = styled.div`
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(14rem, 1fr));
  gap: 1rem;
`

const Stat = styled.div`
  display: flex;
  flex-direction: column;
  gap: 0.25rem;
  padding: 0.75rem;
  border-radius: 0.5rem;
  background: ${(props) => props.theme.palette.grey.grey50};
`

const ThisMonthCard = () => {
  const dispatch = useDispatch()
  const { dashboardStats, profileData, currentMonthTrips, allModes, monthActivity } =
    useSelector((state: AppState) => state.employeePlatform)
  const isContractor =
    profileData?.finchEmploymentType === FinchEmploymentTypes.CONTRACTOR
  const money = useDashboardMoney()

  useEffect(() => {
    dispatch(
      employeePlatformActions.getCurrentMonthTrips(moment().format('MMM YYYY'))
    )
    dispatch(
      employeePlatformActions.getMonthTransactions({
        month: moment().format('YYYY-MM'),
      })
    )
  }, [dispatch])

  const spent = totalPostedSpend(
    monthActivity?.transactions ?? null,
    monthActivity?.authorizations ?? null
  )
  const trips = summarizeTrips(
    monthTripBucket(currentMonthTrips),
    allModes
  )
  const tripValue =
    currentMonthTrips == null ? '—' : String(trips.total)

  return (
    <GridCard
      headerTitle='This Month'
      headerIcon={<InsightsIcon color={palette.primary.pink800} />}
    >
      <Stats>
        <Stat>
          <Text variant='body2' textColor={palette.text.secondary}>
            Total spent
          </Text>
          <Text variant='h2' textColor={palette.primary.pink800}>
            {spent == null ? '—' : money(spent)}
          </Text>
        </Stat>
        {isContractor ? null : (
          <Stat>
            <Text variant='body2' textColor={palette.text.secondary}>
              Tax savings
            </Text>
            <Text variant='h2' textColor={palette.primary.pink800}>
              {dashboardStats ? money(dashboardStats.taxSavings, 0) : '—'}
            </Text>
          </Stat>
        )}
        <Stat>
          <Text variant='body2' textColor={palette.text.secondary}>
            Trips taken
          </Text>
          <Text variant='h2' textColor={palette.primary.pink800}>
            {tripValue}
          </Text>
          {trips.breakdown ? (
            <Text variant='body2' textColor={palette.text.secondary}>
              {trips.breakdown}
            </Text>
          ) : null}
        </Stat>
      </Stats>
    </GridCard>
  )
}

export default ThisMonthCard
